/** Langues autorisées pour la bibliothèque numérique (e-learning). */
export const BIBLIOTHEQUE_LANGUES = [
  { value: 'fr', label: 'Français' },
  { value: 'en', label: 'Anglais' },
  { value: 'es', label: 'Espagnol' },
  { value: 'de', label: 'Allemand' },
  { value: 'it', label: 'Italien' },
  { value: 'pt', label: 'Portugais' },
  { value: 'ar', label: 'Arabe' },
  { value: 'zh', label: 'Chinois' },
] as const;

export type BibliothequeLangueCode = (typeof BIBLIOTHEQUE_LANGUES)[number]['value'];

export function labelLangueBibliotheque(code: unknown) {
  const key = String(code);
  return BIBLIOTHEQUE_LANGUES.find((l) => l.value === key)?.label ?? key;
}
